import { AxiosService } from './';

const getDashboardData = async () => {
  try {
    let axiosData = {
      method: 'get',
      url: 'admin/dashboard',
      isAuthorized: true,
    };
    const response = await AxiosService.hit(axiosData);
    return response.data;
  } catch (error) {
    throw Error(error.message);
  }
};

const getProjectList = async (
  _perPage,
  _page,
  commonSearch,
  is_active,
  sortBy,
  investmentType,
) => {
  try {
    let axiosData = {
      method: 'get',
      url: 'admin/projects',
      isAuthorized: true,
      params: {
        perPage: _perPage || 100,
        page: _page || 1,
        commonSearch: commonSearch,
        is_active: is_active,
        sortBy: sortBy,
        investmentType: investmentType,
      },
    };
    const response = await AxiosService.hit(axiosData);
    return response.data;
  } catch (error) {
    throw Error(error.message);
  }
};

export { getDashboardData, getProjectList };
